/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EffectiveRevenueDto } from '../../models/effective-revenue-dto';

export interface GetEffectiveRevenue$Params {
  id: string;
}

export function getEffectiveRevenue(http: HttpClient, rootUrl: string, params: GetEffectiveRevenue$Params, context?: HttpContext): Observable<StrictHttpResponse<EffectiveRevenueDto>> {
  const rb = new RequestBuilder(rootUrl, getEffectiveRevenue.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EffectiveRevenueDto>;
    })
  );
}

getEffectiveRevenue.PATH = '/v0/effectiveRevenue/{id}';
